import AwsS3Service from '../../services/AwsS3Service';
import awsS3UseCase from './awsS3UseCase';

const awsS3Factory = awsS3UseCase({ AwsS3Service: AwsS3Service() });

export default awsS3Factory;
